import React, { useEffect, useState } from "react";
import { latLngBounds } from "leaflet";
import { ZoomControl, MapContainer, TileLayer, useMap } from "react-leaflet";
import styles from "./mythMap.module.css";
import AppNav from "../appNav/AppNav";
import MapMarker from "../mapMarker/MapMarker";
import { useHistory } from "react-router-dom";

const startCoords = { lat: 54.193629285033104, lng: -3.0943679809570317 };
const startZoom = 14;

export default function MythMap({ mythData }) {
  const [resetTimestamp, setResetTimestamp] = useState(null);
  const [selectedMyth, setSelectedMyth] = useState({});
  const [zoom, setZoom] = useState(14);

  let history = useHistory();

  const onNavMythSelect = (myth) => {
    setSelectedMyth(myth);
    setZoom(18);
  };

  const onDeselectAll = () => {
    setSelectedMyth({});
    setResetTimestamp(Date.now());

    history.push("/");
  };

  return (
    <div className={styles.mythMap}>
      <AppNav
        myths={mythData}
        onMythSelect={onNavMythSelect}
        onShowAll={onDeselectAll}
      />

      <MapContainer
        center={[startCoords.lat, startCoords.lng]}
        zoom={startZoom}
        doubleClickZoom={true}
        scrollWheelZoom={true}
        attributionControl={false}
        zoomControl={false}
        className={styles.map}
      >
        <MapUpdateCenter coords={selectedMyth.location} zoom={zoom} />
        <MapFitToMarkers resetTimestamp={resetTimestamp} mythData={mythData} />

        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <ZoomControl position="bottomleft" />
        {mythData.map((md) => (
          <MapMarker
            key={md.id}
            autoOpen={selectedMyth.id === md.id}
            location={[md.location.lat, md.location.lng]}
            title={md.title}
            excerpt={md.excerpt}
            mythData={md}
            linkTo={`/explorer/${md.id}`}
          />
        ))}
        {/* <LocationMarker /> */}
      </MapContainer>
    </div>
  );
}

function MapUpdateCenter({ coords, zoom }) {
  const map = useMap();

  useEffect(() => {
    if (!coords || !zoom) {
      map.flyTo([startCoords.lat, startCoords.lng], startZoom);
    } else {
      map.flyTo([coords.lat + 0.0003, coords.lng], zoom);
    }
  }, [coords, zoom, map]);

  return null;
}

function MapFitToMarkers({ resetTimestamp, mythData }) {
  const map = useMap();

  useEffect(() => {
    if (!resetTimestamp || !mythData || mythData.length === 0) return;

    let markerBounds = latLngBounds([]);
    mythData.forEach((marker) => {
      markerBounds.extend([marker.location.lat, marker.location.lng]);
    });

    map.fitBounds(markerBounds);
  }, [resetTimestamp, mythData, map]);

  return null;
}
